import { gql } from 'apollo-boost';

export const GET_MY_CHAT_ACTIONS = gql`
    query GetMyChatActions($scope: ChatActionScopeEnum) {
        getMyChatActions(scope: $scope) {
            id
            ownerUserId
            slashCommand
            label
            description
            scope
            visibility
            promptTemplate
            isActive
            isSystem
            createdAt
            updatedAt
        }
    }
`;
